import React from 'react';

export type EmptyComponentProps = {
  testId?: string;
};

export const EmptyComponent: React.FC<EmptyComponentProps> = ({
  testId = 'Empty',
}) => {
  return <div data-testid={testId} />;
};
